import { RoleDataType } from '@/api/RoleApi';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
    data: any;
    isLogin: boolean;
    error: string | null;
    userRoleData?: RoleDataType
}

const initialState: UserState = {
    data: null,
    isLogin: false,
    error: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login(state) {
            state.isLogin = true;
        },
        setUserRole(state, action: PayloadAction<RoleDataType>) {
            state.userRoleData = action.payload;
        },
        logout(state) {
            state.isLogin = false;
        },
    },
    extraReducers() {
    },
});

export const { login, logout, setUserRole } = userSlice.actions;
export default userSlice.reducer;